import React, {Component} from 'react';
import {CardList} from "../card-list/card-list.component";
import './card-container.styles.css';
import {getposts} from "../../../services/posts";
import {Pagination} from "../../common/Pagination.component";
import {paginate} from "../../../utils/paginate";


class CardContainer extends Component {
    constructor() {
        super();

        this.state = {
            posts: getposts(),
            pageSize:9,
            currentPage:1
        }
    }

    /*componentDidMount() {
        fetch('https://jsonplaceholder.typicode.com/posts')
            .then(response =>response.json())
            .then(posts => this.setState({posts: posts}))
    }*/

    handleDelete = (postId) =>{
        //console.log("Event handler Delete",postId);
        const deletePost = this.state.posts.filter(d=>d.id !== postId)
        this.setState({posts: deletePost})
    }

    handleLike = (post) =>{
        console.log("Event handler Like",post);
        const posts = [...this.state.posts];
        const index = posts.indexOf(post);
        posts[index] = {...posts[index]};
        posts[index].liked = !posts[index].liked;
        this.setState({posts});
    }

    handlePageChange = page =>{
        this.setState({currentPage : page});
    }

    render() {
        const {length:count}=this.state.posts;
        const {currentPage,pageSize,posts:allPosts} = this.state;
        const posts = paginate(allPosts,currentPage,pageSize);

        if (count === 0 ) return <h1 className="text-center">There is no post in this Database.</h1>
        return (
            /*<div className="rounded p-2">

                <p className="text-right d-none d-sm-none d-md-block">
                    Shows {count} posts in the Database.
                </p>

                <div className="container mt-5">
                    <CardList
                        onHandleLike={this.handleLike}
                        onHandleDelete={this.handleDelete}
                        posts={this.state.posts}
                    />
                </div>
            </div>*/
            <div className="container my-5">
                <CardList
                    onHandleLike={this.handleLike}
                    onHandleDelete={this.handleDelete}
                    posts={posts}
                />
                <Pagination
                    itemCount={count}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    onHandlePage={this.handlePageChange} />
            </div>
        );
    }
}

export default CardContainer;